import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { map } from 'rxjs';

export const authNoGuard: CanActivateFn = () => {
  return inject(AuthService)
    .check()
    .pipe(map(() => true));
};

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  return authService.check().pipe(
    map((authenticated) => {
      if (!authenticated) {
        authService.signIn();
        return false;
      }
      return true;
    }),
  );
};
